import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyBg } from './bg.directive';
var BgModule = /** @class */ (function () {
    function BgModule() {
    }
    BgModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [LyBg],
                    declarations: [LyBg]
                },] },
    ];
    /** @nocollapse */
    BgModule.ctorParameters = function () { return []; };
    return BgModule;
}());
export { BgModule };
//# sourceMappingURL=bg.module.js.map